import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];

let findById = function(programmeId, courseId) {
    return function(e) { 
        return e !== undefined && e.programmeId == programmeId && e.courseId == courseId;
    }
};

let ProgrammeCourseStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }, 
    getCourses: function (programmeId) {
        return _entities.filter(function(e) {
            return e !== undefined && e.programmeId == programmeId;
        }).sort(function(a, b) {
            return a.listOrder - b.listOrder;
        });
    },
    addCourse: function(course) {
        if (course.programmeId !== undefined && course.courseId !== undefined) {
            let index = _entities.findIndex(findById(course.programmeId, course.courseId));
            if (0 <= index) {
                _entities[index] = course;
            } else {
                _entities.push(course);
            }
        }
    },
    addCourses: function(courses) {
        if (courses instanceof Array) {
            courses.forEach(this.addCourse);
        } else {
            this.addCourse(courses);
        }
    },
    removeCourse: function(data) {
        if (data.programmeId !== undefined && data.courseId !== undefined) {
            let index = _entities.findIndex(findById(data.programmeId, data.courseId));
            if (0 <= index) {
                if (data.success) {
                    delete _entities[index];
                } else {
                    // error; leave item there...
                    _entities[index].loading = false;
                }
            }
        } 
    },
    
});

ProgrammeCourseStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.PROGRAMME_COURSE_LIST:
            ProgrammeCourseStore.addCourses(action.data);
            ProgrammeCourseStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_COURSE_SAVE:
            ProgrammeCourseStore.addCourse(action.data);
            ProgrammeCourseStore.emitChange();
            break;

        case ActionTypes.PROGRAMME_COURSE_SAVE_ERROR:
            ProgrammeCourseStore.emitChange();
            break;
            
        case ActionTypes.PROGRAMME_COURSE_DELETE:
            ProgrammeCourseStore.removeCourse(action.data);
            ProgrammeCourseStore.emitChange();
            break;
            
        default:
            break;

    }

});

export default ProgrammeCourseStore;
